function ProdiSwitch(props) {
    let prodi
    if (props == "Teknik Informatika") {
        prodi = "Computer Science"
    } else if (props == "Sistem Komputer") {
        prodi = "Computer System"
    } else if (props == "Desain Komunikasi Visual") {
        prodi = "Visual Communication Design"
    } else if (props == "Akuntansi") {
        prodi = "Accounting"
    } else if (props = "Manajemen") {
        prodi = "Management"
    }
    return prodi
}

export default ProdiSwitch;